import Api from "@/services/Api";

export default {
  fetch(modulo, path, params) {
    return Api().get(`/${modulo}/${path}/`, {
      params: params,
    });
  },

  getById(modulo, path, id) {
    return Api().get(`/${modulo}/${path}/${id}`);
  },

  getByIdParams(modulo, path, id, params) {
    return Api().get(`/${modulo}/${path}/${id}/`, {
      params: params,
    });
  },

  save(modulo, path, params) {
    if ("id" in params) {
      return Api().put(`/${modulo}/${path}/${params.id}/`, params);
    }
    return Api().post(`/${modulo}/${path}/`, params);
  },

  saveImage(modulo, path, params, file) {
    var form_data = new FormData();
    for (var key in params) {
      let value = params[key];
      if (value === null || value === undefined || value === "null" || value === "None") {
        value = "";
      }
      form_data.append(key, value);
    }
    form_data.append("imagen", file);

    return Api().put(`/${modulo}/${path}/${params.id}` + "/", form_data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  saveImageWithPost(modulo, path, params, file) {
    var form_data = new FormData();

    for (var key in params) {
      let value = params[key];
      if (value === null || value === undefined || value === "null" || value === "None") {
        value = "";
      }
      form_data.append(key, value);
    }
    form_data.append("imagen", file);

    return Api().post(`/${modulo}/${path}/`, form_data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  postAction(modulo, path, id, action, params) {
    return Api().post(`/${modulo}/${path}/${id}/${action}/`, params);
  },

  updateFileWithPost(modulo, path, params, file) {
    var form_data = new FormData();

    for (var key in params) {
      form_data.append(key, params[key]);
    }
    form_data.append("archivo", file);
    return Api().put(`/${modulo}/${path}/${params.id}/`, form_data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  updateMultipleFilesWithPost(modulo, path, params, file1, file2) {
    var form_data = new FormData();
    for (var key in params) {
      form_data.append(key, params[key]);
    }
    if (file1) form_data.append("archivo", file1);
    if (file2) form_data.append("archivo_2", file2);

    return Api().post(`/${modulo}/${path}/${params.id}/subir_archivos_factura/`, form_data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getAction(modulo, path, id, action, params) {
    return Api().get(`/${modulo}/${path}/${id}/${action}/`, {
      params: params,
    });
  },

  postActionList(modulo, path, action, params) {
    return Api().post(`/${modulo}/${path}/${action}/`, params);
  },

  getActionList(modulo, path, action, params) {
    let loading = true;
    if (params != null) {
      if (params.hasOwnProperty('loading')) {
        loading = params['loading'];
      }
    }
    return Api(loading).get(`/${modulo}/${path}/${action}/`, {
      params: params,
    });
  },
  javascriptpostFormData(modulo, path, formData) {
  return Api().post(`/${modulo}/${path}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
},

  delete(modulo, path, id) {
    let url = URL;
    return Api().delete(`/${modulo}/${path}/` + id + "/", {});
  },
};
